import { render } from "./ValueStatement.vue?vue&type=template&id=79556ca0&scoped=true"
import script from "./ValueStatement.vue?vue&type=script&lang=js"
export * from "./ValueStatement.vue?vue&type=script&lang=js"

import "./ValueStatement.vue?vue&type=style&index=0&id=79556ca0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79556ca0"]])

export default __exports__